'use client'
import React, { HTMLAttributes, ReactElement, ReactNode } from 'react'

export interface DataListRowProps extends HTMLAttributes<HTMLLIElement> {
    children: ReactNode
}

export const DataListRow = ({ children, ...rest }: DataListRowProps): ReactElement => (
    <li {...rest} className={rest.className ?? ''}>
        <ul className="w-full flex px-3" role="row">
            {children}
        </ul>
    </li>
)
